import AbstractFetch from './AbstractFetch';

class VersionFetch {
  /**
   * Fetches the information about the latest app version
   * @param {AbortSignal} signal - Optional AbortSignal to cancel the request
   */
  static fetchLatestVersion(signal) {
    const url = `${process.env.PUBLIC_URL}/currentversion.json`;
    return AbstractFetch.fetch(url, {
      method: 'GET',
      signal,
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        console.log(`VersionFetch: ${error}`);
      });
  }
}

export default VersionFetch;
